import * as angular from 'angular';
import { GradPlanningTransferTableComponent } from './grad-planning-transfer-table.component';

export const GradPlanningTransferTableModule = angular
  .module('gradPlanningTransferTable', [])
  .component('gradPlanningTransferTable', GradPlanningTransferTableComponent).name;
